// extracted by mini-css-extract-plugin
module.exports = {"ancillaries":"AncillariesBanner_ancillaries__aMgnz","ancillariesContent":"AncillariesBanner_ancillariesContent__UCZRE"};